var _path, _g, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1083_51218",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12Z",
    fill: "#273B4A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1083_51218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.14212 12.5245L6.00634 12.6602L6.00634 12.6602C5.2732 13.3934 4.90663 13.76 4.6512 14.1889C4.41784 14.5809 4.25324 15.0098 4.16451 15.4572C4.06739 15.947 4.09464 16.4647 4.14913 17.5001L4.44444 23.111H20V18.8953C20 17.8013 20 17.2544 19.8635 16.7453C19.7548 16.3401 19.5831 15.9545 19.3546 15.6027C19.0676 15.1607 18.661 14.7948 17.8479 14.063L17.6572 13.8914C17.0099 13.3088 16.6862 13.0175 16.3341 12.8846C15.8451 12.7001 15.3033 12.7144 14.8246 12.9243C14.48 13.0755 14.1721 13.3834 13.5563 13.9992C13.1001 14.4553 12.8721 14.6834 12.6398 14.7571C12.3169 14.8595 11.9642 14.7916 11.7025 14.5766C11.5142 14.4219 11.3847 14.1199 11.1258 13.5158C10.5683 12.2149 10.2896 11.5645 9.87069 11.2454C9.37316 10.8663 8.72697 10.7419 8.12427 10.909C7.61684 11.0497 7.12527 11.5413 6.14212 12.5245Z",
    stroke: "#1E1E1E",
    strokeWidth: 2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4V4C15.7712 4 17.6569 4 18.8284 5.17157C20 6.34315 20 8.22876 20 12V12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20V20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12V12Z",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 8.5,
    r: 1.5,
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.6cf75da7ae25e0baaa6cd011e710236d.svg";
export { ForwardRef as ReactComponent };